import { PersonalContent } from './PersonalContent';

export default PersonalContent;
